document.addEventListener('DOMContentLoaded', function () {
  function syncInputsOnChange(fromSelector, toSelector) {
    document
      .querySelectorAll(`${fromSelector} .size_slider input`)
      .forEach(input => {
        input.addEventListener('change', function () {
          const value = this.value;
          const targetInput = document.querySelector(
            `${toSelector} .size_slider input[value="${value}"]`
          );

          const variantId = parseInt(input.dataset.variantId);
          const variant = fitnessBandProduct.variants.find(
            item => item.id === variantId
          );

          let rawSrc = this.dataset.variantImgUrl;

          rawSrc = rawSrc.replace(/_\d+x(?=\.png|\.jpg|\.jpeg)/, '');

          const newSrc = rawSrc.replace(/[\?&]width=\d+/, '');
          document
            .querySelectorAll('.tracker-min__media-variant')
            .forEach(picture => {
              const wrapper = picture.closest('.tracker-min, .cta-tracker-min');
              let imgSrcs;

              if (wrapper.classList.contains('tracker-min')) {
                imgSrcs = {
                  media1440: [`${newSrc}&width=320`, `${newSrc}&width=640 2x`],
                  media1024: [`${newSrc}&width=281`, `${newSrc}&width=562 2x`],
                  img: [`${newSrc}&width=204`, `${newSrc}&width=408 2x`]
                };
              } else if (wrapper.classList.contains('cta-tracker-min')) {
                const disclaimerEl = wrapper.querySelector('.prod_disclaimer');

                if (disclaimerEl) {
                  wrapper.querySelector('.text').textContent = variant.available
                    ? disclaimerEl.dataset.available
                    : disclaimerEl.dataset.notAvailable;
                }

                imgSrcs = {
                  media1440: [`${newSrc}&width=313`, `${newSrc}&width=626 2x`],
                  media1024: [`${newSrc}&width=281`, `${newSrc}&width=562 2x`],
                  img: [`${newSrc}&width=354`, `${newSrc}&width=708 2x`]
                };
              }

              const source1440 = picture.querySelector(
                'source[media="(min-width: 1440px)"]'
              );
              const source1024 = picture.querySelector(
                'source[media="(min-width: 1024px)"]'
              );
              const img = picture.querySelector('img');

              if (source1440)
                source1440.setAttribute('srcset', imgSrcs.media1440.join(', '));
              if (source1024)
                source1024.setAttribute('srcset', imgSrcs.media1024.join(', '));
              img.setAttribute('srcset', imgSrcs.img.join(', '));
              img.setAttribute('alt', variant.featured_media.alt);
            });

          if (targetInput) {
            targetInput.click();
          }
        });
      });
  }

  syncInputsOnChange('.tracker-min.main', '.cta-tracker-min');
  syncInputsOnChange('.cta-tracker-min', '.tracker-min.main');

  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return msie > 0 || trident > 0;
  }

  if (isIE()) {
    const hiddenInput = document.querySelector(
      '#{{ product_form_id }} input[name="id"]'
    );
    const noScriptInputWrapper = document.createElement('div');
    const variantSwitcher =
      document.querySelector(
        'variant-radios[data-section="{{ section.id }}"]'
      ) ||
      document.querySelector(
        'variant-selects[data-section="{{ section.id }}"]'
      );
    noScriptInputWrapper.innerHTML = document.querySelector(
      '.product-form__noscript-wrapper-{{ section.id }}'
    ).textContent;
    variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

    document
      .querySelector('#Variants-{{ section.id }}')
      .addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
  }

  document.addEventListener('scroll', function () {
    let offset = window.pageYOffset || document.documentElement.scrollTop;
    const desktopBg = document.getElementById('parallax-bg-desktop');
    const mobileBg = document.getElementById('parallax-bg-mobile');
    if (desktopBg) {
      desktopBg.style.transform = 'translateY(' + offset * 0.1 + 'px)';
    }
    if (mobileBg) {
      mobileBg.style.transform = 'translateY(' + offset * 0.1 + 'px)';
    }
  });
});
